import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import './AdminNavbar.css';
import Logo from '../Images/GudnetNewLogo.webp';

const AdminNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setIsLoggedIn(true);
      setUserName(user.first_name || "Profile");
    }
  }, []);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of the system.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, log me out!'
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("user");
        localStorage.removeItem("userId");
        localStorage.removeItem("userPlan");
        localStorage.removeItem("userStartDate");
        localStorage.removeItem("userEnddate");
        setIsLoggedIn(false);
        navigate("/");
        Swal.fire(
          'Logged Out!',
          'You have been successfully logged out.',
          'success'
        );
      }
    });
  };

  const isActive = (path) => location.pathname === path;
  const isProfileActive = ["/", "/myaccount", "/add-employee", "/employees", "/manage-jobs"].includes(location.pathname);

  return (
    <Navbar expand="xl" bg="white" variant="light" fixed="top" className="admin-navbar">
      <Container>
        <Navbar.Brand
          className="admin-navbar-brand"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/admindashboard")}
        >
          <img src={Logo} alt="Gudnet Logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="admin-navbar-collapse" />
        <Navbar.Collapse id="admin-navbar-collapse">
          <Nav className="admin-navbar-nav mx-auto">
            <Nav.Link href="/admindashboard" className={isActive("/admindashboard") ? "admin-active" : ""}>DASHBOARD</Nav.Link>

            <NavDropdown title="VERIFICATION" id="admin-verification-dropdown" className={isActive("/manageemployee") || isActive("/managejobs") || isActive("/manageallagency") ? "admin-active" : ""}>
              <NavDropdown.Item href="/manageemployee" className={isActive("/manageemployee") ? "admin-dropdown-active" : ""}>All Candidate</NavDropdown.Item>
              <NavDropdown.Item href="/managejobs" className={isActive("/managejobs") ? "admin-dropdown-active" : ""}>All Employer</NavDropdown.Item>
              <NavDropdown.Item href="/manageallagency" className={isActive("/manageallagency") ? "admin-dropdown-active" : ""}>All Agencies</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="MANAGE PLANS" id="admin-plans-dropdown" className={isActive("/managecandidatesubscriptionplans") || isActive("/manageemployersubscriptionplans") || isActive("/manageagencysubscriptionplans") || isActive("/managesubscriptionplans") || isActive("/admin-payments") ? "admin-active" : ""}>
              <NavDropdown.Item href="/managecandidatesubscriptionplans" className={isActive("/managecandidatesubscriptionplans") ? "admin-dropdown-active" : ""}>Manage Candidate Plans</NavDropdown.Item>
              <NavDropdown.Item href="/manageemployersubscriptionplans" className={isActive("/manageemployersubscriptionplans") ? "admin-dropdown-active" : ""}>Manage Employer Plans</NavDropdown.Item>
              <NavDropdown.Item href="/manageagencysubscriptionplans" className={isActive("/manageagencysubscriptionplans") ? "admin-dropdown-active" : ""}>Manage Agency Plans</NavDropdown.Item>
              <NavDropdown.Item href="/managesubscriptionplans" className={isActive("/managesubscriptionplans") ? "admin-dropdown-active" : ""}>All Subscription Plans</NavDropdown.Item>
              <NavDropdown.Item href="/admin-payments" className={isActive("/admin-payments") ? "admin-dropdown-active" : ""}>Payments &amp; Subscribers</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="MASTERS" id="admin-masters-dropdown" className={isActive("/managejobpositions") || isActive("/managenews") || isActive("/manageavailablejobs") ? "admin-active" : ""}>
              <NavDropdown.Item href="/managejobpositions" className={isActive("/managejobpositions") ? "admin-dropdown-active" : ""}>Manage Job Positions</NavDropdown.Item>
              <NavDropdown.Item href="/manageabout" className={isActive("/manageabout") ? "admin-dropdown-active" : ""}>Manage Youtube Video</NavDropdown.Item>
              <NavDropdown.Item href="/managefootercontent" className={isActive("/managefootercontent") ? "admin-dropdown-active" : ""}>Manage Footer Content</NavDropdown.Item>
              <NavDropdown.Item href="/manageavailablejobs" className={isActive("/manageavailablejobs") ? "admin-dropdown-active" : ""}>Manage Available Jobs Ad</NavDropdown.Item>
              <NavDropdown.Item href="/managenews" className={isActive("/managenews") ? "admin-dropdown-active" : ""}>Manage News</NavDropdown.Item>
              <NavDropdown.Item href="/managetips" className={isActive("/managetips") ? "admin-dropdown-active" : ""}>Manage Tips</NavDropdown.Item>
              <NavDropdown.Item href="/managetrainings" className={isActive("/managetrainings") ? "admin-dropdown-active" : ""}>Manage Trainings</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="FAKE REPORTINGS" id="admin-reports-dropdown" className={isActive("/reportedcandidatesadmin") || isActive("/reportedjob") ? "admin-active" : ""}>
              <NavDropdown.Item href="/reportedjob" className={isActive("/reportedjob") ? "admin-dropdown-active" : ""}>Job Reports</NavDropdown.Item>
              <NavDropdown.Item href="/reportedcandidatesadmin" className={isActive("/reportedcandidatesadmin") ? "admin-dropdown-active" : ""}>Candidate Reports</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="ENQUIRIES" id="admin-enquiries-dropdown" className={isActive("/enquiry-detail") || isActive("/supportmessages") || isActive("/manageshortlist") || isActive("/admin-lead-bot-leads") ? "admin-active" : ""}>
              <NavDropdown.Item href="/enquiry-detail" className={isActive("/enquiry-detail") ? "admin-dropdown-active" : ""}>Enquiry Detail</NavDropdown.Item>
              <NavDropdown.Item href="/supportmessages" className={isActive("/supportmessages") ? "admin-dropdown-active" : ""}>Support Messages</NavDropdown.Item>
              <NavDropdown.Item href="/manageshortlist" className={isActive("/manageshortlist") ? "admin-dropdown-active" : ""}>Shortlist Candidates</NavDropdown.Item>
              <NavDropdown.Item href="/admin-lead-bot-leads" className={isActive("/admin-lead-bot-leads") ? "admin-dropdown-active" : ""}>Lead Bot Leads</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="OUTREACH" id="admin-outreach-dropdown" className={isActive("/admin-instant-message") || isActive("/admin-bulk-outreach") ? "admin-active" : ""}>
              <NavDropdown.Item href="/admin-instant-message" className={isActive("/admin-instant-message") ? "admin-dropdown-active" : ""}>Instant Message</NavDropdown.Item>
              <NavDropdown.Item href="/admin-bulk-outreach" className={isActive("/admin-bulk-outreach") ? "admin-dropdown-active" : ""}>Bulk Outreach</NavDropdown.Item>
            </NavDropdown>
          </Nav>

          <div className="admin-navbar-profile">
            <NavDropdown title={<><i className="bi bi-person-circle me-1"></i>{userName}</>} id="admin-profile-dropdown">
              <NavDropdown.Item href="/myaccountadmin" className={isActive("/myaccountadmin") ? "admin-dropdown-active" : ""}>MY ACCOUNT</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout} className="text-danger"><i className="bi bi-box-arrow-right me-2"></i>Logout</NavDropdown.Item>
            </NavDropdown>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AdminNavbar;
